import { render } from "./FeeBenchmark.vue?vue&type=template&id=0bcf7632&scoped=true"
import script from "./FeeBenchmark.vue?vue&type=script&lang=js"
export * from "./FeeBenchmark.vue?vue&type=script&lang=js"

import "./FeeBenchmark.vue?vue&type=style&index=0&id=0bcf7632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcf7632"]])

export default __exports__